import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { BaseEntityService } from "./rest-common.service";
import { NotificationService } from "src/app/notification.service";

@Injectable({
  providedIn: "root",
})
export class ChatBotService extends BaseEntityService {
  public resource_url = `${this.BASE_AI_BOT_URL}/chatbot/`;

  constructor(public http: HttpClient, public toastr: NotificationService) {
    super();
  }

}
